// extracted by mini-css-extract-plugin
export var legendIndicator = "_df-1";
export var legendRight = "_df-0";